import { createContext, useState } from 'react';

const PageContext = createContext();

const PageProvider = (props) => {
    const [filters, setFilters] = useState({
        open: false,
        sort: 'none',
        search: '',
    });

    const resetFilters = () => {
        setFilters((current) => ({
            ...current,
            sort: 'none',
        }));
    };

    return (
        <PageContext.Provider
            value={{
                filters,
                setFilters,
                resetFilters,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
